import { create } from 'zustand'
import type { User } from '@/types/api'

/**
 * Auth state (plan §8): the short-lived access token lives ONLY in memory —
 * never localStorage — so a page refresh starts empty and the bootstrap
 * mints a new one from the httpOnly refresh cookie. The refresh token itself
 * is invisible to JS by design.
 */
interface AuthState {
  accessToken: string | null
  user: User | null
  setAuth: (token: string, user?: User | null) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  setAuth: (accessToken, user) =>
    set((s) => ({ accessToken, user: user !== undefined ? user : s.user })),
  clearAuth: () => set({ accessToken: null, user: null }),
}))
